import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_secretStoreUnique', ['secret'], { unique: true })
@Entity('_secret_store')
export class SecretStoreEntity extends BaseEntity {
	@Column('varchar', {
		name: '_secret',
		nullable: true,
		unique: true,
		length: 50,
	})
	public secret!: string | null;

	@Column('text', { name: '_data' })
	public data!: string;

	@Column('varchar', { name: '_key', length: 50 })
	public key!: string;
}
